<template lang="html">
    <div v-show='$store.state.LoadingOnOff' id='waitingMask'>
        <div class="loader">
            <div class="loader-inner ball-beat">
                <div class="themeBg"></div>
                <div class="themeBg"></div>
                <div class="themeBg"></div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
      name:'waiting',
        props: {},
        data: function () {
            return {}
        },
        created: function () {

        },
        mounted: function () {

        },
        methods: {},
        components: {},
        computed: {},
    }
</script>

<style scoped>
  /*等待遮罩*/
  @-webkit-keyframes ball-beat {
    50% {
      filter:alpha(opacity=0.2);
      -moz-opacity:0.2;
      -khtml-opacity:0.2;
      opacity:0.2;
      -webkit-transform: scale(0.75);
      transform: scale(0.75);
    }
    100% {
      filter:alpha(opacity=1);
      -moz-opacity:1;
      -khtml-opacity:1;
      opacity:1;
      -webkit-transform: scale(1);
      transform: scale(1);
    }
  }


  #waitingMask{
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(250,250,250,0.7);
    z-index: 100;
    text-align: center;
    padding-top: 60%;
  }
  #waitingMask .loader{display: inline-block;background-color: initial; }
  #waitingMask .ball-beat{background-color: initial; }
  #waitingMask .ball-beat > div {
    background-color: #FF8D27;
    width: 28px;
    height: 28px;
    border-radius: 100%;
    margin: 2px;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
    display: inline-block;
    -webkit-animation: ball-beat 0.7s 0s infinite linear;
    animation: ball-beat 0.7s 0s infinite linear;
  }
  #waitingMask .ball-beat > div:nth-child(2n-1) {
    -webkit-animation-delay: 0.35s !important;
    animation-delay: 0.35s !important; }

</style>



// WEBPACK FOOTER //
// src/components/Waitting/waiting.vue